import getIsChrome from "selectors/device/getIsChrome";
import { createSelector } from "reselect";

// Most devices use Infinity as the default duration for a video element. Android 7.1 has a default duration of 0.
// Seeking past the end of a video causes the video to go to the end so in this case it would be 0.

const getWaitForDurationChangeToSeek = createSelector(
  getIsChrome,
  (isChrome) => isChrome,
);

export default getWaitForDurationChangeToSeek;
